import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './AuthProvider'


export const RequireAuth = () => {
const { session, loading } = useAuth()
if (loading) return <div className="p-8">Загрузка…</div>
if (!session) return <Navigate to="/login" replace />
return <Outlet />
}